"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _hoc = require("@apollo/client/react/hoc");
var _apollo = require("../../apollo");
var _getCachedUser = _interopRequireDefault(require("../../utils/getCachedUser"));
const withUserAndPreferences = function (Component) {
  let queryOptions = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return props => {
    if (props.headerApi.isPilet) {
      return /*#__PURE__*/_react.default.createElement(Component, Object.assign({
        data: (0, _getCachedUser.default)(props.headerApi)
      }, props, {
        preferencesFromNetwork: true
      }));
    }
    const options = {
      fetchPolicy: 'cache-only',
      ...queryOptions
    };

    // @ts-ignore
    const GraphQLComponent = (0, _hoc.graphql)(_apollo.preferencesAndUserQuery, {
      options
    })(Component);
    return /*#__PURE__*/_react.default.createElement(GraphQLComponent, Object.assign({}, props, {
      preferencesFromNetwork: options.fetchPolicy === 'cache-and-network'
    }));
  };
};
var _default = exports.default = withUserAndPreferences;